import axios from 'axios';
import {
  PURGE_AUTH,
} from '../store/mutation-types';
import Storage from '@/utils/storage';

const $http = axios.create();

const BASE_API_URL = process.env.VUE_APP_BASE_API_URL;

const Http = {
  getBaseApiUrl() {
    return BASE_API_URL;
  },
  initHeader() {
    $http.defaults.headers.common['Content-Type'] = 'application/json';
    const token = Storage.get('token');

    if (token) {
      $http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
  },
  resetHeader() {
    $http.defaults.headers.common['Content-Type'] = 'application/json';

    const token = Storage.get('token');

    if (token) {
      $http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
  },
  get(resource, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.get(`${BASE_API_URL}${resource}`, configMerged);
  },
  post(resource, data, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.post(`${BASE_API_URL}${resource}`, data, configMerged);
  },
  put(resource, data, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.put(`${BASE_API_URL}${resource}`, data, configMerged);
  },
  delete(resource, loading = true, config = {}) {
    const configMerged = Object.assign({}, { loading }, config);

    return $http.delete(`${BASE_API_URL}${resource}`, configMerged);
  },
};

/* Interceptor - 401 */
$http.interceptors.response.use(
  response => response,
  (error) => {
    if (error.request.status === 401) {
      // Go login page
      store.dispatch(PURGE_AUTH);
    }

    return Promise.reject(error);
  },
);

Http.initHeader();
export default Http;
